import { Component, OnDestroy, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ContactCardDto } from '@hub/generated/models';

@Component({
  selector: 'fm-contact-card',
  templateUrl: 'form-contact-card.component.html',
  styles: [
    `
.card-bg {
  background-color: #f4f3f4;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.card-icon-bg {
  border: 1px solid #d9d9d9;
}

.card-icon-bg:hover {
  background-color: #d9d9d9;
}
.padding-x {
  padding: 0 5px;
}
    `
  ]
})
export class FormContactCardComponent
  implements OnInit {
  constructor() { }

  @Output() onRemove: EventEmitter<any> = new EventEmitter();
  @Input() contact: ContactCardDto;
  @Input() isEditable: boolean;

  isNotObject: boolean;

  ngOnInit() {
  }

  openLink() {
    if(this.contact && this.contact.ContactConnectUrlAddress) {
      window.open(this.contact.ContactConnectUrlAddress, "_blank");
    }
  }

  remove() {
    this.onRemove.emit(this.contact);
  }
}
